export const SET_DYNAMIC_ITEMS = 'QUESTION_PREVIEW/SET_DYNAMIC_ITEMS';
export const REMOVE_DYNAMIC_ITEMS = 'QUESTION_PREVIEW/REMOVE_DYNAMIC_ITEMS';
export const SET_QUESTION_PROPS = 'QUESTION_PREVIEW/SET_QUESTION_PROPS';
